module.exports = __webpack_public_path__ + "static/media/harvest.57275cb3.png";